import { SearchOutlined } from '@ant-design/icons';
import React, { ReactElement, useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { isBlankArray } from '../../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../../store';

interface ICustomFilterDropdownIcon {
  filtered?: boolean;
  filterKey: string;
}

const CustomFilterDropdownIcon = ({filterKey}: ICustomFilterDropdownIcon): ReactElement => {
  const [color, setColor] = useState('#bfbfbf' as any);
  const filters = useSelector((state: RootState): any => state?.selectedInPatientDetail?.filters || {});
  useEffect((): any => {
    if (Array.isArray(filters[filterKey])) {
      setColor((filters[filterKey].length > 0 && !isBlankArray(filters[filterKey])) ? '#3c3ada' : '#bfbfbf');
    } else {
      setColor((filters[filterKey]) ? '#3c3ada' : '#bfbfbf');
    }
  }, [filters]);
  return (
    <React.Fragment>
      <SearchOutlined style={{ color }} />
    </React.Fragment>
  );
};
export default CustomFilterDropdownIcon;
